// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ohUJI","fullView":"styles_fullView__1nXog"};